import { fileOptionalValidate, fileRequiredValidate } from "validators";
import * as yup from "yup";

const createDriverValidator = yup
  .object({
    first_name: yup.string().required("First name is required"),
    middle_name: yup.string().required("Middle name is required"),
    last_name: yup.string().required("Last name is required"),
    local_full_name: yup.string().required("Local full name is required"),
    phone: yup
      .string()
      .required("Phone is required")
      .test("phone", "Invalid phone format. e.g +251912345678", (value) => {
        return /^\+251(9|7)[0-9]{8}$/.test(value);
      }),
    backup_phone: yup
      .string()
      .required("Backup phone is required")
      .test("phone", "Invalid phone format. e.g +251912345678", (value) => {
        return /^\+251(9|7)[0-9]{8}$/.test(value);
      }),
    date_of_birth: yup.string().required("Date of birth is required"),
    email: yup.string().email("Enter a valid email").nullable(),
    gender: yup.string().required("Gender is required"),
    city_id: yup.string().required("City is required"),
    tin_number: yup.string().required("TIN number is required"),
    image: yup
      .mixed()
      .required("Image is required")
      .test("image-required", "Image is required", fileRequiredValidate),
    business_license_images: yup
      .mixed()
      .required("Business license image is required")
      .test(
        "image-required",
        "Business license image is required",
        fileRequiredValidate
      )
      .required("Business license image is required"),
    bolo_image: yup
      .mixed()
      .required("Bolo image is required")
      .test("image-required", "Bolo image is required", fileRequiredValidate),
    driving_license_image: yup
      .mixed()
      .required("Driving license image is required")
      .test(
        "image-required",
        "Driving license image is required",
        fileRequiredValidate
      ),
    insurance_subscription_image: yup
      .mixed()
      .required("Insurance subscription image is required")
      .test(
        "image-required",
        "Insurance subscription image is required",
        fileRequiredValidate
      ),
    employment_agreement_image: yup
      .mixed()
      .test("image-required", "Image is required", fileOptionalValidate),
    owner_id_image: yup
      .mixed()
      .test("image-required", "Image is required", fileOptionalValidate),
    driver_id_image: yup
      .mixed()
      .test("image-required", "Image is required", fileOptionalValidate),
    maheber_support_image: yup
      .mixed()
      .test("image-required", "Image is required", fileOptionalValidate),
  })
  .required();

export default createDriverValidator;

export const updateDriverValidator = yup
  .object({
    first_name: yup.string().required("First name is required"),
    middle_name: yup.string().required("Middle name is required"),
    last_name: yup.string().required("Last name is required"),
    phone: yup
      .string()
      .required("Phone is required")
      .test("phone", "Invalid phone format. e.g +251912345678", (value) => {
        return /^\+251(9|7)[0-9]{8}$/.test(value);
      }),
    local_full_name: yup.string().required("Local full name is required"),
    backup_phone: yup
      .string()
      .required("Backup phone is required")
      .test("phone", "Invalid phone format. e.g +251912345678", (value) => {
        return /^\+251(9|7)[0-9]{8}$/.test(value);
      }),
    date_of_birth: yup.string().required("Date of birth is required"),
    email: yup.string().email("Enter a valid email").nullable(),
    gender: yup.string().required("Gender is required"),
    city_id: yup.string().required("City is required"),
    tin_number: yup.string().required("TIN number is required"),
    image: yup
      .mixed()
      .test("image-required", "Image is required", fileOptionalValidate),
    business_license_images: yup
      .mixed()
      .test("image-required", "Image is required", fileOptionalValidate),
    driving_license_image: yup
      .mixed()
      .test("image-required", "Image is required", fileOptionalValidate),
    insurance_subscription_image: yup
      .mixed()
      .test("image-required", "Image is required", fileOptionalValidate),
    employment_agreement_image: yup
      .mixed()
      .test("image-required", "Image is required", fileOptionalValidate),
    owner_id_image: yup
      .mixed()
      .test("image-required", "Image is required", fileOptionalValidate),
    driver_id_image: yup
      .mixed()
      .test("image-required", "Image is required", fileOptionalValidate),
    maheber_support_image: yup
      .mixed()
      .test("image-required", "Image is required", fileOptionalValidate),
    bolo_image: yup
      .mixed()
      .test("image-required", "Image is required", fileOptionalValidate),
  })
  .required();
